import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { dressCode } from '@/mocks/applicationData';

export default function DressCodeSection() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('application.dress.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {lang === 'en' ? t('application.dress.title') : dressCode.title}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {dressCode.titleEn}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {lang === 'en' ? t('application.dress.lead') : dressCode.lead}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {dressCode.items.map((item, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 p-5 flex items-start gap-4 group"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/10 flex-shrink-0">
                <i className={`${item.icon} text-accent-600 text-sm`}></i>
              </div>
              <div>
                <h4 className="text-[16px] text-foreground-900 tracking-[0.05em] font-medium mb-1">
                  {lang === 'en' ? t(`application.dress.item.${idx}.name`) : item.name}
                </h4>
                <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                  {lang === 'en' ? t(`application.dress.item.${idx}.desc`) : item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <img
            src="/images/generated/application-dresscode-2026.jpg"
            alt={lang === 'en' ? t('application.dress.imageAlt') : dressCode.imageAlt}
            className="w-full h-auto"
          />
          <p className="text-[13px] text-foreground-400 tracking-[0.04em] mt-3">
            {t('application.dress.imgCaption')}
          </p>
        </div>
      </div>
    </section>
  );
}
